/* tslint:disable */
/* eslint-disable */
/**
 * SupportService
 * Operation workflow management system
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CreateSupportFlagRequest } from '../model';
// @ts-ignore
import { SupportFlagDto } from '../model';
/**
 * SupportFlagsApiApiSupportFlagsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SupportFlagsApiApiSupportFlagsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SupportFlags`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SupportFlagsApiApiSupportFlagsIsSupportSecondaryPhoneNumberActiveGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SupportFlagsApiApiSupportFlagsIsSupportSecondaryPhoneNumberActiveGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SupportFlags/IsSupportSecondaryPhoneNumberActive`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SupportFlagsApiApiSupportFlagsNameTogglePatch - axios parameter creator
 * 
 * @param {string} name 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SupportFlagsApiApiSupportFlagsNameTogglePatchAxiosParamCreator (name: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'name' is not null or undefined
    assertParamExists('apiSupportFlagsNameTogglePatch', 'name', name)
    const localVarPath = `/api/SupportFlags/{name}/toggle`
        .replace(`{${"name"}}`, encodeURIComponent(String(name)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SupportFlagsApiApiSupportFlagsPost - axios parameter creator
 * 
 * @param {CreateSupportFlagRequest} [createSupportFlagRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SupportFlagsApiApiSupportFlagsPostAxiosParamCreator (createSupportFlagRequest?: CreateSupportFlagRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SupportFlags`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createSupportFlagRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiSupportFlagsNameTogglePatch operation in SupportFlagsApi.
 * @export
 * @interface SupportFlagsApiApiSupportFlagsNameTogglePatchRequest
 */
export interface SupportFlagsApiApiSupportFlagsNameTogglePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportFlagsApiApiSupportFlagsNameTogglePatch
     */
    readonly name: string
}

/**
 * Request parameters for apiSupportFlagsPost operation in SupportFlagsApi.
 * @export
 * @interface SupportFlagsApiApiSupportFlagsPostRequest
 */
export interface SupportFlagsApiApiSupportFlagsPostRequest {
    /**
     * 
     * @type {CreateSupportFlagRequest}
     * @memberof SupportFlagsApiApiSupportFlagsPost
     */
    readonly createSupportFlagRequest?: CreateSupportFlagRequest
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SupportFlagsApiApiSupportFlagsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SupportFlagsApiApiSupportFlagsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<SupportFlagDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SupportFlagsApiApiSupportFlagsIsSupportSecondaryPhoneNumberActiveGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SupportFlagsApiApiSupportFlagsIsSupportSecondaryPhoneNumberActiveGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<SupportFlagDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SupportFlagsApiApiSupportFlagsNameTogglePatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SupportFlagsApiApiSupportFlagsNameTogglePatch(requestParameters: SupportFlagsApiApiSupportFlagsNameTogglePatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SupportFlagsApiApiSupportFlagsNameTogglePatchAxiosParamCreator(requestParameters.name, options, configuration);
    const request: () => AxiosPromise<SupportFlagDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SupportFlagsApiApiSupportFlagsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SupportFlagsApiApiSupportFlagsPost(requestParameters: SupportFlagsApiApiSupportFlagsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SupportFlagsApiApiSupportFlagsPostAxiosParamCreator(requestParameters.createSupportFlagRequest, options, configuration);
    const request: () => AxiosPromise<SupportFlagDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
